import { ReadonlyVec3 } from 'gl-matrix';
import { DvfGeometry, dvfPatientToVoxel } from '~/domain/dvf/dvfField';
import { inferno } from '~/utils/colormap';

const MIN_OPACITY = 0.12;
const MAX_OPACITY = 0.55;

export interface UncertaintyCell {
    readonly index: number;
    readonly fill: string;
}

export function uncertaintyCellFill(valueMm: number, maxMm: number): string {
    const t = maxMm > 0 ? Math.min(valueMm / maxMm, 1) : 0;
    const [r, g, b] = inferno(t);
    const alpha = MIN_OPACITY + (MAX_OPACITY - MIN_OPACITY) * t;
    return `rgba(${r},${g},${b},${alpha.toFixed(3)})`;
}

// Nearest-voxel reading; points outside the field and zero spread draw nothing.
export function uncertaintyCells(
    points: readonly ReadonlyVec3[],
    geometry: DvfGeometry,
    values: Float32Array,
    maxMm: number
): UncertaintyCell[] {
    const [nx, ny] = geometry.size;
    const cells: UncertaintyCell[] = [];
    points.forEach((point, index) => {
        const voxel = dvfPatientToVoxel(geometry, point);
        if (!voxel) {
            return;
        }
        const value = values[(voxel[2] * ny + voxel[1]) * nx + voxel[0]];
        if (value > 0) {
            cells.push({ index, fill: uncertaintyCellFill(value, maxMm) });
        }
    });
    return cells;
}
